module.exports = __webpack_public_path__ + "static/img/cdr.3556a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/cdr.png
// module id = uq+v
// module chunks = 53